import { useNavigate } from 'react-router-dom';
import { StarRating } from './StarRating';

export default function ProfileCard({ profile }) {
  const navigate = useNavigate();
  const isManager = profile.type === 'manager';

  return (
    <div
      onClick={() => navigate(`/profile/${profile.id}`)}
      style={{
        background: '#FAF6EC',
        border: '1px solid rgba(184,137,58,0.22)',
        borderRadius: 16,
        boxShadow: '0 2px 8px rgba(120,90,30,0.06)',
        padding: '16px', cursor: 'pointer', transition: 'box-shadow 0.15s', marginBottom: 12,
      }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 16px rgba(120,90,30,0.16)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(120,90,30,0.06)'}
    >
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <div style={{
          width: 48, height: 48, borderRadius: 12, flexShrink: 0,
          background: '#0F2C4E',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 15, fontWeight: 600,
          color: '#fff',
        }}>
          {profile.photo
            ? <img src={profile.photo} alt={profile.name} style={{ width: '100%', height: '100%', borderRadius: 12, objectFit: 'cover' }} />
            : profile.initials}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 15, fontWeight: 600, color: '#0F2C4E' }}>{profile.name}</span>
            <span className={`badge ${isManager ? 'badge-blue' : 'badge-green'}`}>
              {isManager ? 'Manager' : 'Tenant'}
            </span>
          </div>
          {profile.address && (
            <div style={{ fontSize: 12, color: '#6B6358', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {profile.address}
            </div>
          )}
          {isManager && (
            <div style={{ marginTop: 8 }}>
              <StarRating rating={profile.rating} size={13} showNumber reviewCount={profile.reviewCount} />
            </div>
          )}
          {!isManager && profile.rentalHistory?.length > 0 && (
            <div style={{ fontSize: 12, color: '#6B6358', marginTop: 6 }}>
              {profile.rentalHistory.length} rental{profile.rentalHistory.length > 1 ? 's' : ''} on record
            </div>
          )}
        </div>
        <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="#B8893A" strokeWidth={2} style={{ flexShrink: 0, marginTop: 2 }}>
          <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      {isManager && profile.reviews?.length > 0 && (
        <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid rgba(184,137,58,0.18)' }}>
          <p style={{ fontSize: 12, color: '#6B6358', fontStyle: 'italic', lineHeight: 1.5 }}>
            "{profile.reviews[0].text.substring(0, 90)}{profile.reviews[0].text.length > 90 ? '...' : ''}"
          </p>
        </div>
      )}
    </div>
  );
}
